import { schema } from 'normalizr';

const OPTIN_SCHEMA = new schema.Entity('optins', {}, { idAttribute: '@id' });
const SIGNATURE_REQUEST_SCHEMA = new schema.Entity('signatureRequests', {}, { idAttribute: '@id' });

export default {
  Optin: OPTIN_SCHEMA,
  SignatureRequest: SIGNATURE_REQUEST_SCHEMA,
};
